export enum RestrictionsType {
  WHITE_LIST = 'WHITE_LIST',
  BLACK_LIST = 'BLACK_LIST'
}
